export default __webpack_public_path__ + "static/media/logo.b686fc19.png";